import { FaClipboardList, FaExternalLinkAlt, FaEye, FaEyeSlash, FaFileAlt, FaHistory, FaList, FaNotesMedical, FaPen, FaQuestionCircle, FaSpinner } from "react-icons/fa";
import { BACKEND } from "../../config/configEnvs";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Modal from "../ui/Modal";
import { useSelector } from "react-redux";
import Tooltip from "../ui/ToolTip";
import HistoricChangesModal from "./HistoricChangesModal";
import DescriptionModal from "./DescriptionModal";
import { PlanBackgroundColor } from "../../utils/GetTextColor";
import ChipInfo from "./ChipInfo";
import HandleUpdateSelectSelf from "../../utils/HandleUpdateSelectSelf";
import { standardServiceStatus } from "../../utils/rawData/serviceStatus";

const AudiovisualBoxItemContainer = ({ service, client, user, permissions, allServiciosList, workers }) => {

  const debounceUpdate = useRef(null); // Referencia para mantener el debouncer

  const [newComment, setNewComment] = useState("");

  const [openModal, setOpenModal] = useState(false)

  const [serviceData, setServiceData] = useState(() => 
    client.services.find((serv) => serv.servicio.name === service.name)
  );

  const getStatusClass = (estado) => { // Color del texto del estado del servicio
    switch (estado) {
      case "Terminado con exito":
          return "text-green-500 font-bold";
      case "Por comenzar":
          return "text-yellow-300 font-bold";
      case "En proceso":
          return "text-blue-500 font-bold";
      case "Abandonado":
          return "text-black font-bold";
      case "Congelado":
          return "text-sky-300 font-bold";
      default:
          return "text-gray-500 font-bold";
    }
  };

  /// Historial de cambios

  const [openModalHistory, setOpenModalHistory] = useState(false) // Modal de historial de cambios

  const handleUpdateField = async (field, newStatus) => { // Cambiar el campo
    const changeHistory = serviceData.historialCambios ? [...serviceData.historialCambios] : [];

    const newChange = {
      worker: user,
      field: field,
      oldValue: serviceData[field],
      newValue: newStatus,
      date: new Date().toISOString(),
    };

    changeHistory.push(newChange);

    const transformedHistory = changeHistory.map(change => ({
      ...change,
      worker: change.worker.id, // Solo enviar el id del trabajador, no el objeto completo
    }));

    //console.log(transformedHistory)

    try {
      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${serviceData.id}`, {
        [field]: newStatus === "Seleccionar" ? null : newStatus,
        historialCambios: transformedHistory, // Enviar el array actualizado
      });

      toast.success("Estado actualizado con éxito");
  
      setServiceData((prevData) => ({
        ...prevData,
        [field]: newStatus,
        historialCambios: changeHistory,
      }));
    } catch (error) {
      console.error(error);
      toast.error("Error al actualizar el estado");
    }
  };

  const handleUpdateDate = (field, newDate) => { // Cambiar la fecha con lógica de debouncer

    setServiceData((prevData) => ({
      ...prevData,
      [field]: newDate,
    }));

    if (debounceUpdate.current) {
      clearTimeout(debounceUpdate.current);
    }
    debounceUpdate.current = setTimeout(async () => {

      try {
        const changeHistory = serviceData.historialCambios ? [...serviceData.historialCambios] : [];

        const newChange = {
          worker: user,
          field: field,
          oldValue: serviceData[field],
          newValue: newDate,
          date: new Date().toISOString(),
        };

        changeHistory.push(newChange);

        const transformedHistory = changeHistory.map(change => ({
          ...change,
          worker: change.worker.id, // Solo enviar el id del trabajador, no el objeto completo
        }));

        await axios.put(`${BACKEND}/api/serviciosCotizaciones/${serviceData.id}`, {
          [field]: newDate || null,
          historialCambios: transformedHistory, // Enviar el array actualizado
        });

        setServiceData((prevData) => ({
          ...prevData,
          historialCambios: changeHistory,
        }));

        toast.success("Fecha actualizada con éxito");
      } catch (error) {
        console.error(error);
        toast.error("Error al actualizar la fecha");
      }
    }, 2000); // Esperar 2 secs luego de que el usuario deja de ecsribir
  };

  const handleAddComment = async () => { // Añadir comentario al servicio
    if (!newComment.trim()) {
      toast.error("Por favor, ingresa un comentario antes de enviar.");
      return;
    }
  
    // Crear un nuevo objeto de comentario con la estructura correcta
    const nuevoComentario = {
      usuario: user.id,
      comentario: newComment,
      fecha: new Date().toISOString(), // Asegúrate de enviar la fecha en formato ISO
    };
  
    // Asegúrate de que comentariosOperativa sea un array (si no existe, inicialízalo como un array vacío)
    const comentariosOperativa = serviceData.comentariosOperativa || [];
  
    // Actualizar el estado local antes de hacer la solicitud
    setServiceData((prevData) => ({
      ...prevData,
      comentariosOperativa: [
        ...comentariosOperativa, // Mantener los comentarios previos
        nuevoComentario, // Agregar el nuevo comentario
      ],
    }));
  
    try {
      // Enviar la solicitud para agregar el nuevo comentario al backend
      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${serviceData.id}`, {
        comentariosOperativa: serviceData.comentariosOperativa,
      });
  
      toast.success("Comentario agregado con éxito");
  
      // Limpiar el campo de texto después de agregar el comentario
      setNewComment("");
    } catch (error) {
      console.error(error);
      toast.error("Error al agregar el comentario");
    }
  };

  // Ver descripción del servicio

  const [openModalDescription, setOpenModalDescription] = useState(false)

  const parseDescription = (description) => { // Parsear la info
    if (!description || typeof description !== "string") {
      return [];
    }
    return description.split("\n").map((item) => {
      const [key, value] = item.split(":");
      return {
        key: key ? key.trim() : "",
        value: value ? (value.trim() === "✓" ? "Si" : value.trim()) : "-",
      };
    });
  };  

  const descriptionText = serviceData?.customDescriptionActive
  ? serviceData?.customDescriptionText
  : serviceData?.servicio.preciosUnitarios.find(
      (precioUnit) => precioUnit?.plan.id === serviceData?.planServicio.id
    )?.descripcion;

  const parsedDescription = parseDescription(descriptionText);
  
  return (
    <td scope="row" className="px-4 py-2 max-w-xs border border-gray-300 truncate text-center">
      {(() => {
        if (serviceData) {
          return (
            <div className="flex flex-col gap-1">

              <Modal
                activeModal={openModal}
                onClose={() => setOpenModal(false)}
                title="Comentarios proyecto"
                centered
              >
                <div className="flex flex-col gap-2">

                  <div className="text-xs text-gray-800 font-semibold text-lg">
                    <span className="font-bold">Cliente: </span>
                    <span className="font-light">{serviceData?.cotizacion?.cliente?.nombreComercial}</span>
                  </div>

                  <div className="text-xs text-gray-800 font-semibold text-lg">
                    <span className="font-bold">Servicio: </span>
                    <span className="font-light">{serviceData.servicio.name}</span>
                  </div>

                  <h3 className="text-xs font-bold text-gray-700 mt-3">Comentarios:</h3>
                  {/* Sección de comentarios */}
                  <div className="max-h-[300px] overflow-y-auto">
                    {serviceData.comentariosOperativa?.map((comment, index) => (
                      <div key={index} className="mb-2 px-4 py-2 rounded-lg border border-gray-200 shadow-sm bg-white">

                        <div className="flex flex-row justify-between items-center space-x-3 mb-2">
                          <div className="flex flex-row gap-2 items-center justify-center">
                            <img
                              src={comment?.usuario?.foto?.url || user?.foto?.url}
                              alt={comment?.usuario?.nombre || user.nombre}
                              className="w-8 h-8 rounded-full object-cover"
                            />
                            <span className="text-xs font-semibold text-gray-800">{comment?.usuario?.name || user.name} - <span className="text-xs font-light text-gray-600 lowercase">{comment?.usuario.puesto || user.puesto}</span></span>
                          </div>
                          <div className="text-xs text-gray-500">{new Date(comment.fecha).toLocaleString()}</div>
                        </div>

                        <div className="text-gray-700 text-xs border bordar-gray-200 rounded-md px-2 py-1">{comment.comentario}</div>
                      </div>
                    ))}
                  </div>

                  {/* Sección para agregar un nuevo comentario */}
                  <div className="mt-3">
                    <h3 className="text-xs font-bold text-gray-700">Añadir comentario:</h3>
                    <textarea
                      className="w-full p-3 mt-2 border text-xs border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      rows="2"
                      placeholder="Escribe tu comentario aquí..."
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                    />
                    <button
                      onClick={handleAddComment}
                      className="mt-3 px-4 py-2 bg-blue-600 text-xs text-white rounded-md hover:bg-blue-700 focus:outline-none"
                    >
                      Agregar Comentario
                    </button>
                  </div>
                </div>
              </Modal>

              <HistoricChangesModal
                openModalHistory = {openModalHistory}
                brandName = {serviceData.servicio.name}
                serviceName = {serviceData?.cotizacion?.cliente?.nombreComercial}
                historicChanges = {serviceData.historialCambios}
                parsedDescription = {parsedDescription}
                setOpenModalHistory = {setOpenModalHistory}
                user = {user}
              />

              <DescriptionModal
                openModalDescription = {openModalDescription}
                brandName = {serviceData.servicio.name}
                serviceName = {serviceData?.cotizacion?.cliente?.nombreComercial}
                parsedDescription = {parsedDescription}
                setOpenModalDescription = {setOpenModalDescription}
              />

              {/* Ir al proyecto */}
              <div className="mb-1 flex flex-row justify-between">

                <div>
                  <a 
                    href={`/home/seguimiento/${serviceData.cotizacion.cliente.id}/${serviceData.servicio.name}/${serviceData.id}`}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex flex-row justify-center items-center gap-2 font-bold hover:cursor-pointer hover:underline transition-all duration-100"
                  >
                    Ir al Proyecto
                    <FaExternalLinkAlt />
                  </a>
                </div>
                  
                <Tooltip content={"Historial de cambios"}>
                  <div onClick={() => setOpenModalHistory(true)}>
                    <FaHistory className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                  </div>
                </Tooltip>

              </div>

              {/* Plan */}
              <div className="mb-1 flex flex-row justify-between">
                <span className="font-semibold">Plan: </span>
                <span className={`font-semibold px-2 ${PlanBackgroundColor[serviceData.planServicio.name]}`}>
                  {serviceData.planServicio.name}
                </span>
              </div>

              {/* Checklist */}
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">CheckList: </span>
                  {ChipInfo("Sistema")}
                </div>
                <span className={`text-xs ${serviceData.checklistCompleted || serviceData.checkList === "Si" ? "text-green-500" : "text-red-500"}`}>
                  {serviceData.checklistCompleted || serviceData.checkList === "Si" ? "Si" : "No"}
                </span>
              </div>

              {/* Estado */}
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">Estado: </span>
                  {ChipInfo("Asistente")}
                </div>
                <select 
                  value={serviceData.estado}
                  onChange={(e) => handleUpdateField("estado", e.target.value)}
                  className={`px-2 py-0 w-[40%] hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs ${getStatusClass(serviceData.estado)}`}
                  disabled={!(permissions.isAdmin && permissions.isAssistant && permissions.isBossArea)}
                >
                  {standardServiceStatus.map((status) => (
                    <option value={status.value} className={`${status.color} hover:cursor-pointer`}>{status.icon} {status.label}</option>
                  ))}
                </select>
              </div>

              {/* Fecha ingreso */}
              <div className="flex flex-row justify-between">
                <div className="flex flex-row gap-1">
                  <span className="font-semibold">Fecha Ingreso: </span>
                  {ChipInfo("Sistema")}
                  <Tooltip content={"Fecha de cuando se registró la venta en el sistema"}>
                    <div>
                      <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                    </div>
                  </Tooltip>
                </div>
                <input
                  type="date"
                  value={serviceData.fechaIngreso ? serviceData.fechaIngreso.split('T')[0] : ""}
                  onChange={(e) => handleUpdateDate("fechaIngreso", e.target.value)}
                  disabled={!permissions.isAdmin}
                  className={`px-2 w-[40%] py-0 hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                />
              </div>

              {/* Fecha inicio */}
              <div className="flex flex-row justify-between">
                <div className="flex flex-row gap-1">
                  <span className="font-semibold">Fecha Inicio: </span>
                  {ChipInfo("Sistema")}
                  <Tooltip content={"Fecha establecida para iniciar el proyecto"}>
                    <div>
                      <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                    </div>
                  </Tooltip>
                </div>
                <input
                  type="date"
                  value={serviceData.fechaInicio ? serviceData.fechaInicio.split('T')[0] : ""}
                  onChange={(e) => handleUpdateDate("fechaInicio", e.target.value)}
                  disabled={!permissions.isAdmin}
                  className={`px-2 w-[40%] py-0 hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                />
              </div>

              {/* Fecha fin contrato */}
              <div className="flex flex-row justify-between">
                <div className="flex flex-row gap-1">
                  <span className="font-semibold">Fecha fin contrato:: </span>
                  {ChipInfo("Admin")}
                  <Tooltip content={"Fecha de finalización del contrato"}>
                    <div>
                      <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                    </div>
                  </Tooltip>
                </div>
                <input
                  type="date"
                  value={serviceData.fechaFin ? serviceData.fechaFin.split('T')[0] : ""}
                  onChange={(e) => handleUpdateDate("fechaFin", e.target.value)}
                  disabled={!permissions.isAdmin}
                  className={`px-2 w-[40%] py-0 hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                />
              </div>

              {/* Días para la finalización */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">
                  {serviceData.estado === 'Terminado con exito' ? (
                    // Si está "Terminado con exito"
                    serviceData.fechaFin && serviceData.fechaEntrega ? (
                      Math.ceil((new Date(serviceData.fechaFin).getTime() - new Date(serviceData.fechaEntrega).getTime()) / (1000 * 60 * 60 * 24)) < 0
                        ? "Días de retraso: " // Si la diferencia es negativa (retraso)
                        : "Días que sobraron: " // Si la diferencia es positiva (no hubo retraso)
                    ) : (
                      "-"
                    )
                  ) : (
                    // Si está en proceso
                    "Días para la finalización: "
                  )}
                </span>
                
                {serviceData.estado === 'Terminado con exito' ? (
                  // Si está "Terminado con exito"
                  serviceData.fechaFin && serviceData.fechaEntrega ? (
                    <span
                      className={`font-bold ${
                        Math.ceil((new Date(serviceData.fechaFin).getTime() - new Date(serviceData.fechaEntrega).getTime()) / (1000 * 60 * 60 * 24)) < 0
                          ? 'text-red-500' // Si hay retraso
                          : 'text-green-500' // Si no hay retraso
                      }`}
                    >
                      {Math.abs(Math.ceil((new Date(serviceData.fechaFin).getTime() - new Date(serviceData.fechaEntrega).getTime()) / (1000 * 60 * 60 * 24)))}
                    </span>
                  ) : (
                    "-"
                  )
                ) : (
                  // Si está en proceso
                  serviceData.fechaFin ? (
                    <span
                      className={`font-bold ${
                        new Date(serviceData.fechaFin).getTime() < new Date().getTime() ? 'text-red-500' : 'text-green-500'
                      }`}
                    >
                      {Math.ceil((new Date(serviceData.fechaFin).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))}
                    </span>
                  ) : (
                    "-"
                  )
                )}
              </div>

              {/* Duración del proyecto */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">
                  {serviceData.estado === 'Terminado con exito' ? (
                    // Si está "Terminado con exito"
                    serviceData.fechaInicio && serviceData.fechaEntrega ? (
                      "Duración del proyecto: "
                    ) : (
                      "-"
                    )
                  ) : (
                    // Si está en proceso
                    "Duración hasta la fecha: "
                  )}
                </span>

                {serviceData.estado === 'Terminado con exito' ? (
                  // Si está "Terminado con exito"
                  serviceData.fechaInicio && serviceData.fechaEntrega ? (
                    <span className="font-bold text-green-500">
                      {Math.ceil((new Date(serviceData.fechaEntrega).getTime() - new Date(serviceData.fechaInicio).getTime()) / (1000 * 60 * 60 * 24))}
                    </span>
                  ) : (
                    "-"
                  )
                ) : (
                  // Si está en proceso
                  serviceData.fechaInicio ? (
                    <span className="font-bold text-green-500">
                      {Math.ceil((new Date().getTime() - new Date(serviceData.fechaInicio).getTime()) / (1000 * 60 * 60 * 24))}
                    </span>
                  ) : (
                    "-"
                  )
                )}
              </div>

              {/* Link plan de trabajo */}
              <div className="flex flex-row justify-between items-center">
                <span className="font-semibold">Link plan de trabajo: </span>
                {serviceData.linkPlanTrabajo ? (
                  <a 
                    href={serviceData.linkPlanTrabajo}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                  >
                    <span>Link</span>
                    <FaExternalLinkAlt className="text-blue-500" />
                  </a>
                ) : (
                  <span>No registrado</span>
                )}
              </div>

              {/* Link recursos */}
              <div className="flex flex-row justify-between items-center">
                <span className="font-semibold">Link recursos: </span>
                {serviceData.linkRecursos ? (
                  <a 
                    href={serviceData.linkRecursos}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                  >
                    <span>Link</span>
                    <FaExternalLinkAlt className="text-blue-500" />
                  </a>
                ) : (
                  <span>No registrado</span>
                )}
              </div>

              {/* Precio venta */}
              {user.area.toUpperCase() === "ADMINISTRACION" && (
                <div className="flex flex-row justify-between">

                  <div className="flex flex-row gap-1">
                    <span className="font-semibold">Precio Venta: </span>
                  </div>
  
                  <span>
                  {serviceData.cotizacion.moneda}{" "}
                    {(() => {
                      const servicioEncontrado = allServiciosList.find(
                        (e) => e.id === serviceData.servicio.id
                      );
  
                      const precioUnitario = servicioEncontrado?.preciosUnitarios?.find(
                        (ev2) => ev2.plan?.id === serviceData.planServicio?.id
                      )?.precio;
  
                      const precioBase = serviceData.customPriceActive
                        ? serviceData.customPrice * serviceData.numeroItems
                        : precioUnitario
                        ? precioUnitario * serviceData.numeroItems
                        : 0; // Si no encuentra el precio, evitar que sea undefined
  
                      // Calcular el descuento
                      let montoDescuento = 0;
                      if (serviceData.tipoDescuento === "Porcentaje") {
                        montoDescuento = precioBase * (serviceData.montoDescuento / 100);
                        console.log(montoDescuento)
                      } else if (serviceData.tipoDescuento === "Fijo") {
                        montoDescuento = serviceData.montoDescuento;
                      }
  
                      // Restar el descuento del precio base
                      return precioBase - montoDescuento;
                    })()}
                  </span>
  
                </div>
              )}

              {/* Encargado */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Encargado: </span>
                <span>{serviceData.cotizacion?.cliente?.encargadoProyecto ? `${serviceData.cotizacion?.cliente?.encargadoProyecto}` : "-"}</span>
              </div>

              {/* Nro. Encargado */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Nro. Encargado: </span>
                <span>{serviceData.cotizacion?.cliente?.telefono ? `${serviceData.cotizacion?.cliente?.telefono}` : "-"}</span>
              </div>

              {/* Vendedor */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Vendedor: </span>
                <span>{serviceData.cotizacion?.cotizador?.name ? `${serviceData.cotizacion?.cotizador?.name}` : "-"}</span>
              </div>

              {/* Responsable cobranza */}
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">Responsable cobranza: </span>
                  <Tooltip content={"Vendedor responsable de la cobranza del proyecto."}>
                    <div>
                      <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                    </div>
                  </Tooltip>
                  {ChipInfo("Admin")}
                </div>
                <select 
                  value={serviceData?.encargadoCobranza ? (serviceData?.encargadoCobranza?.id || serviceData.encargadoCobranza) : serviceData.cotizacion?.cotizador?.id}
                  onChange={(e) => HandleUpdateSelectSelf("encargadoCobranza", e.target.value, serviceData.id, "serviciosCotizaciones", setServiceData)}
                  className={`px-2 py-0 w-[40%] hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                  disabled={!permissions.isAdmin && !permissions.isAssistant}
                >
                  {workers.map(worker => (
                    <option key={worker.id} value={worker.id} className="hover:cursor-pointer">{worker.name}</option>
                  ))}
                </select>
              </div>

              {/* Responsable */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Responsable: </span>
                <span>{serviceData.responsable?.name ? `${serviceData.responsable?.name}` : "-"}</span>
              </div>

              {/* Comentarios vendedor */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Comentarios vendedor: </span>
                {serviceData.comentarioVendedor ? (
                  <Tooltip content={`${serviceData.comentarioVendedor}`} interactive={true}>
                    <div>
                      <FaEye className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                    </div>
                  </Tooltip>
                ) : (
                  <div>
                    <FaEyeSlash />
                  </div>
                )}
              </div>

              {/* Descripción servicio */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Descripción servicio: </span>
                {parsedDescription ? (
                <button 
                  onClick={() => setOpenModalDescription(true)}
                  className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                >
                  <span>Ver</span>
                  <FaFileAlt className="text-blue-500" />
                </button>

                ) : (
                  <div>
                    <FaEyeSlash />
                  </div>
                )}
              </div>

              {/* Comentarios proyecto */}
              <div className="flex mt-1 items-center justify-center">
                <button 
                  onClick={() => setOpenModal(true)}
                  className="flex flex-row justify-center items-center gap-2 font-bold hover:cursor-pointer hover:underline transition-all duration-100"
                >
                  Comentarios proyecto
                  <FaPen className="text-blue-500"/>
                </button>
              </div>
              
              {/* Audios */}
              {serviceData.audios && serviceData.audios?.length > 0 && (
                <div className="flex flex-col gap-2">
                  <span className="font-semibold text-left">Audios: </span>
                  <div className="flex flex-col gap-2 w-full">
                    {serviceData.audios.map((audio) => (
                      <div className="flex items-center gap-2">
                        <audio 
                          src={audio.url} 
                          controls 
                          className="w-full h-4 [&::-webkit-media-controls-time-remaining-display]:text-xs [&::-webkit-media-controls-current-time-display]:text-xs"
                          controlsList="nodownload"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              {/* Servicios vinculados */}
              {serviceData.associatedServices && serviceData.associatedServices?.length > 0 && (
                <div className="flex mt-2 gap-2 flex-wrap">
                  <span className="font-semibold">Servicios vinculados: </span>
                  {serviceData.associatedServices?.map(associatedService => (
                    <a 
                      key={associatedService.serviceId} // Siempre añade un key al map
                      href={`/home/seguimiento/${associatedService.brandId}/${associatedService.serviceName}/${associatedService.serviceId}`}
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="flex items-center justify-center px-2 py-0.5 bg-orange-500 rounded-full text-white font-semibold text-xs hover:bg-orange-600 transition-all"
                    >
                      {associatedService.serviceName}
                    </a>
                  ))}
                </div>
              )}

            </div>
          );
        } else {
          return (
            <span className="text-xs text-gray-200">-</span>
          );
        }
      })()}
    </td>
  )
}

export default AudiovisualBoxItemContainer